import React from 'react'
import PT from 'prop-types'
import Dialog from '@vimcar/shared-components/components/Dialog'
import DialogActions from '@vimcar/shared-components/components/DialogActions'
import TextField from '@vimcar/shared-components/components/TextField'

import i18n from '#utils/i18n'
import styles from './styles.css'

const tp = i18n.prefix('components.BookingDialog')

const BookingDialog = ({
  children,
  className,
  end,
  licenseplate,
  loading,
  makeModel,
  onPrimary,
  onRequestClose,
  onSecondary,
  primaryLabel,
  primaryProps,
  secondaryLabel,
  start,
  title,
}) => (
  <Dialog
    className={className}
    footer={() => (
      <DialogActions
        onPrimary={onPrimary}
        onSecondary={onSecondary}
        primaryDisabled={loading}
        primaryLabel={primaryLabel || tp('confirm')}
        primaryProps={primaryProps}
        secondaryDisabled={loading}
        secondaryLabel={secondaryLabel || i18n.t('global.cancel')}
        />
    )}
    onClose={onRequestClose || onSecondary}
    title={title}
    >
    <div className={styles.grid}>
      <TextField
        readOnly
        className={styles.field}
        floatingLabelText={tp('pickup')}
        value={start}
        />
      <TextField
        readOnly
        className={styles.field}
        floatingLabelText={tp('dropoff')}
        value={end}
        />
      <TextField
        readOnly
        className={styles.field}
        floatingLabelText={tp('make-model')}
        value={makeModel}
        />
      <TextField
        readOnly
        className={styles.field}
        floatingLabelText={tp('licenseplate')}
        value={licenseplate}
        />
    </div>
    {children}
  </Dialog>
)

BookingDialog.propTypes = {
  children: PT.node,
  className: PT.string,
  end: PT.string.isRequired,
  licenseplate: PT.string.isRequired,
  loading: PT.bool.isRequired,
  makeModel: PT.string.isRequired,
  onPrimary: PT.func,
  onRequestClose: PT.func,
  onSecondary: PT.func,
  primaryLabel: PT.string,
  primaryProps: PT.object,
  secondaryLabel: PT.string,
  start: PT.string.isRequired,
  title: PT.string.isRequired,
}

export default BookingDialog
